import './resume.scss';
import Resume from './resume';

export default Resume;
